import React from 'react';
import { XCircleIcon, CheckCircle2Icon } from 'lucide-react';
import { RichText } from './RichText';
import { afterItems, beforeItems, brandName, pills } from '../../data/landing';
export function BeforeAfter() {
  return <section aria-labelledby="before-after-title" className="bg-sand py-16 md:py-24" data-id="element-6" data-mp="vc1dgbryho33">
      <div className="mx-auto grid max-w-6xl gap-10 px-5 lg:grid-cols-[0.9fr_1.1fr] lg:items-center lg:gap-16" data-id="element-7" data-mp="zdd7cthv4vh3">
        <div data-id="element-8" data-mp="1n37hh3ass5xn">
          <h2 id="before-after-title" className="font-serif text-[2.4rem] leading-[1.05] text-ink md:text-6xl" data-id="element-9" data-mp="1n2pdtllt2pfp">
            De improvisar antes de cada sesión a <em className="text-primary" data-id="element-10" data-mp="1e1r7uxrt47uh">llegar con todo listo.</em>
          </h2>
          <div className="mt-8 inline-flex items-center gap-4 rounded-2xl bg-paper px-6 py-5" data-id="element-11" data-mp="1j0atex2hnhmb">
            <span className="font-serif text-5xl leading-none text-accent md:text-6xl" data-id="element-12" data-mp="2m2ki5an56t5">10</span>
            <span className="max-w-[15rem] text-sm leading-snug text-muted" data-id="element-13" data-mp="2of8p06zsden">
              <strong className="font-bold text-ink" data-id="element-14" data-mp="7mgv9v3mmuuv">horas semanales</strong> que hoy podés dedicar a buscar y preparar
              materiales
            </span>
          </div>
        </div>

        <div className="grid grid-cols-2 overflow-hidden rounded-3xl border border-line bg-paper" data-id="element-15" data-mp="27b5hc9s3moxd">
          <div className="p-5 md:p-8" data-id="element-16" data-mp="2m867i8un6btq">
            <p className="flex items-center gap-2 font-serif text-lg uppercase tracking-wide text-accent" data-id="element-17" data-mp="2h81ooc69h50c">
              <XCircleIcon className="h-6 w-6 shrink-0" aria-hidden="true" data-id="element-18" data-mp="2v71dpkxorlx1" />
              Antes
            </p>
            <ul className="mt-6 space-y-5" data-id="element-19" data-mp="2q989gxfy11ze">
              {beforeItems.map(item => <li key={item} className="flex gap-3 text-[15px] leading-snug text-ink" data-id="element-20" data-mp="34xvz6n33yhhf">
                  <XCircleIcon className="mt-0.5 h-4 w-4 shrink-0 text-accent/70" aria-hidden="true" data-id="element-21" data-mp="2zyjg8dfcxuk4" />
                  {item}
                </li>)}
            </ul>
          </div>
          <div className="border-l border-line bg-primary-soft p-5 md:p-8" data-id="element-22" data-mp="39wpfen9s4mla">
            <p className="flex items-center gap-2 font-serif text-lg uppercase leading-tight tracking-wide text-primary" data-id="element-23" data-mp="39ucrlthcbi0b">
              <CheckCircle2Icon className="h-6 w-6 shrink-0" aria-hidden="true" data-id="element-24" data-mp="3lygzlfvu9uk7" />
              <span data-id="element-25" data-mp="3lwdxhxhewaz4">
                Con <RichText text={brandName} data-id="element-26" data-mp="3qxa3qhp8k97p" />
              </span>
            </p>
            <ul className="mt-6 space-y-5" data-id="element-27" data-mp="3vojrtdv4z4hh">
              {afterItems.map(item => <li key={item} className="flex gap-3 text-[15px] font-semibold leading-snug text-ink" data-id="element-28" data-mp="3vqd0eypb7ys4">
                  <CheckCircle2Icon className="mt-0.5 h-4 w-4 shrink-0 text-primary" aria-hidden="true" data-id="element-29" data-mp="3n3rurxw28kq" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>

      <ul className="mx-auto mt-14 flex max-w-6xl flex-wrap justify-center gap-3 px-5" data-id="element-30" data-mp="iijo93lxygka">
        {pills.map(p => <li key={p.label} className="flex min-w-[7.5rem] flex-col items-center rounded-full bg-paper px-7 py-4 shadow-sm" data-id="element-31" data-mp="2fbbqznp3jup9">
            <span className="font-serif text-2xl leading-none text-ink" data-id="element-32" data-mp="2k9mznv3nnz5w">
              <RichText text={p.value} data-id="element-33" data-mp="11fabz7mufr26" />
            </span>
            <span className="mt-1.5 text-[11px] font-semibold uppercase tracking-[0.14em] text-muted" data-id="element-34" data-mp="wnk0uzg30z9p">{p.label}</span>
          </li>)}
      </ul>
    </section>;
}